import { parseOptional, parseDate } from "@syla/shared/types/helpers/parsing";
import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { GetAccountResponse } from "@syla/shared/types/responses/GetAccountResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

import { parseSubscription } from "../plans/parseSubscription";

export async function getAccount(
  accountId: string,
): Promise<GetAccountResponse> {
  try {
    const response = await axios.get<TransportType<GetAccountResponse>>(
      `/accounts/${accountId}`,
    );
    return deserialise(response.data);
  } catch (error) {
    throwSylaApiError(error);
  }
}

function deserialise(
  data: TransportType<GetAccountResponse>,
): GetAccountResponse {
  return {
    ...data,
    createdAt: parseOptional(data.createdAt, parseDate),
    updatedAt: parseOptional(data.updatedAt, parseDate),
    subscriptions: data.subscriptions.map(parseSubscription),
  };
}
